import React, {useState, Fragment, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
// import { useForm } from "../Form/index";
import {Dialog, Transition} from '@headlessui/react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import SelectComponent from '../../Selects/SelectComponent';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import ExitForm from '../../ExitFormModal';
import CreateIcon from '@mui/icons-material/Create';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import {Ripple, Tooltip, initTE} from 'tw-elements';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import {useContext} from 'react';
import {Context} from '../../../Helpers/Auth';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';

function DrawerFilter({
    showForm,
    setShowForm,
    setEditarLead,
    download,
    setDownload,

    editarLead,

    onChangeForm,

    setGuardarLead,
    leadSelecionado,
    setLeadSelecionado,
    setNovaConta,
    setNovaReuniaoVisita,

    filtroNome,
    setFiltroNome,
    filtroRazaoSocial,
    setFiltroRazaoSocial,
    setFiltroNIF,
    filtroNIF,
    filtroStatus,
    setFiltroStatus,
    filtroCategoria,
    setFiltroCategoria,
    filtroMarca,
    setFiltroMarca,
    setFiltroNacionalInternacional,
    filtroNacionalInternacional,
    filtroTipo,
    setFiltroTipo,
    filtroModelo,
    setFiltroModelo,
    filtroCidade,
    setFiltroCidade,
    setFiltroPais,
    filtroPais,
    optionsPais,
    optionsStatus,
    optionsMarca,
    optionsNacionaisInternacionais,
    optionsTipo,
    optionsModelo,
    categorias,
    filtroRepresentante,
    setFiltroRepresentante,
    optionsRepresentante,
}) {
    const {t} = useTranslation();

    const [openExit, setOpenExit] = useState(false);

    const {isCard, setIsCard, openCards, setOpenCards} = useContext(Context);
    const [isMobile, setIsMobile] = useState(false);

    initTE({Ripple, Tooltip});

    const [state, setState] = useState({
        right: false,
    });

    const toggleDrawer = (anchor, open) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({...state, [anchor]: open});
    };

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const closeDrawer = anchor => {
        setState({...state, [anchor]: false});
    };
    function limparFiltros() {
        setFiltroNome('');
        setFiltroRazaoSocial(null);
        setFiltroRepresentante('');
        setFiltroNIF('');
        setFiltroStatus(null);
        setFiltroCategoria(null);
        setFiltroMarca(null);
        setFiltroNacionalInternacional(null);
        setFiltroTipo(null);
        setFiltroModelo(null);
        setFiltroCidade('');
        setFiltroPais(null);
    }

    function showButton(params) {
        if (
            filtroNome != '' ||
            filtroRazaoSocial != '' ||
            filtroRepresentante != null ||
            filtroCidade != '' ||
            filtroNIF != '' ||
            filtroStatus != null ||
            filtroCategoria != null ||
            filtroMarca != null ||
            filtroNacionalInternacional != null ||
            filtroTipo != null ||
            filtroModelo != null ||
            filtroPais != null
        ) {
            return true;
        } else {
            return false;
        }
    }

    const list = anchor => (
        <ClickAwayListener onClickAway={() => closeDrawer(anchor)}>
            <Box sx={{width: 320}} role="presentation" className="h-full  bg-white w-80 dark:bg-gray-800">
                <h5 id="drawer-label" className="inline-flex p-4 items-center mb-6 text-base font-semibold text-blue-600 uppercase dark:text-blue-600">
                    <FilterAltIcon className="mr-2" />
                    {t('filtros')}
                </h5>
                <button
                    type="button"
                    data-drawer-hide="drawer-contact"
                    aria-controls="drawer-contact"
                    onClick={() => {
                        closeDrawer(anchor);
                    }}
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-blue-600 rounded-[8px] text-sm w-8 h-8 absolute top-2.5 right-2.5 inline-flex items-center justify-center dark:hover:bg-blue-600 dark:hover:text-white">
                    <CloseIcon />
                    <span className="sr-only">Close menu</span>
                </button>
                <div className="mb-6 p-4">
                    <div>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                </svg>
                            </div>
                            <input
                                type="search"
                                id="default-search"
                                value={filtroNome}
                                className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder={t('filtroNome')}
                                onChange={e => {
                                    setFiltroNome(e.target.value);
                                }}
                            />
                        </div>
                        <div className="relative mt-4">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                </svg>
                            </div>
                            <input
                                type="search"
                                id="default-search"
                                value={filtroRazaoSocial}
                                className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder={t('filtroNomeEmpresa')}
                                onChange={e => {
                                    setFiltroRazaoSocial(e.target.value);
                                }}
                            />
                        </div>

                        <div className="relative mt-4">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                </svg>
                            </div>
                            <input
                                type="search"
                                id="default-search"
                                value={filtroNIF}
                                className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder={t('filtroNif')}
                                onChange={e => {
                                    setFiltroNIF(e.target.value);
                                }}
                            />
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('status')}
                            </label>
                            <SelectComponent
                                options={optionsStatus}
                                value={filtroStatus}
                                onChange={e => {
                                    setFiltroStatus(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtroStatus')}
                            />
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('representante')}
                            </label>
                            <SelectComponent
                                options={optionsRepresentante}
                                value={filtroRepresentante}
                                onChange={e => {
                                    setFiltroRepresentante(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtroRep')}
                            />
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('categoria')}
                            </label>
                            <SelectComponent
                                options={categorias}
                                value={filtroCategoria}
                                onChange={e => {
                                    setFiltroCategoria(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtroCategoria')}
                            />
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('marca')}
                            </label>
                            <SelectComponent
                                options={optionsMarca}
                                value={filtroMarca}
                                onChange={e => {
                                    setFiltroMarca(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtroMarca')}
                            />
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('nacionalInternacional')}
                            </label>
                            <SelectComponent
                                options={optionsNacionaisInternacionais.filter(o => filtroMarca && o.dep === filtroMarca.value)}
                                value={filtroNacionalInternacional}
                                onChange={e => {
                                    setFiltroNacionalInternacional(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtroNacional')}
                            />
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('tipo')}
                            </label>
                            <SelectComponent
                                options={optionsTipo.filter(o => !filtroNacionalInternacional || o.dep === filtroNacionalInternacional.value)}
                                value={filtroTipo}
                                onChange={e => {
                                    setFiltroTipo(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtroFamilia')}
                            />
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('modelo')}
                            </label>
                            <SelectComponent
                                options={optionsModelo.filter(o => !filtroTipo || o.dep === filtroTipo.value)}
                                value={filtroModelo}
                                onChange={e => {
                                    setFiltroModelo(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtroModelo')}
                            />
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('pais')}
                            </label>
                            <SelectComponent
                                options={optionsPais}
                                value={filtroPais}
                                onChange={e => {
                                    setFiltroPais(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtroPais')}
                            />
                        </div>
                        {showButton() && (
                            <div className="flex flex-row justify-end mt-4">
                                <button
                                    type="button"
                                    onClick={() => limparFiltros()}
                                    className="flex items-center font-semibold text-sm justify-center text-white bg-red-700 rounded-[8px] py-1 px-2 hover:bg-red-800 dark:bg-red-600 dark:hover:bg-red-700 focus:ring-4 focus:ring-red-300 focus:outline-none dark:focus:ring-red-800">
                                    {t('limparFiltros')} <CloseRoundedIcon />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </Box>
        </ClickAwayListener>
    );

    return (
        <>
            <div className="flex flex-row items-center">
                {!showForm && !isMobile && (
                    <>
                        <div className="flex items-center mr-3">
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input type="checkbox" checked={isCard} onChange={() => setIsCard(!isCard)} className="sr-only peer" />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('modoCard')}</span>
                            </label>
                        </div>
                    </>
                )}
                {!showForm && isCard && (
                    <div className="flex items-center mr-3">
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" checked={openCards} onChange={() => setOpenCards(!openCards)} className="sr-only peer" />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('abrirCards')}</span>
                        </label>
                    </div>
                )}

                <div className="inline-flex mb-4 rounded-[8px] shadow-sm" role="group">
                    {/* Botao do filtros */}

                    {/* Botao do filtros */}
                    {!showForm && (
                        <button
                            title={t('filtros')}
                            type="button"
                            onClick={toggleDrawer('right', true)}
                            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-200 rounded-l-[8px] hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                            <FilterAltIcon />
                        </button>
                    )}
                    {/* Botao do Download file */}
                    {!showForm && (
                        <button
                            title={t('Download')}
                            type="button"
                            onClick={() => {
                                setDownload(true);
                            }}
                            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                            <FileDownloadRoundedIcon />
                        </button>
                    )}

                    {/* Botão de voltar */}
                    {showForm && (
                        <button
                            title={t('voltar')}
                            type="button"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10 dark:bg-blue-700 text-blue-700 focus:ring-blue-700 focus:ring-2 rounded-l-[8px] dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}
                            onClick={() => {
                                if (onChangeForm) {
                                    setOpenExit(true);
                                } else {
                                    setShowForm(false);
                                    setEditarLead(false);
                                    setLeadSelecionado(null);
                                }
                            }}>
                            {<KeyboardBackspaceRoundedIcon />}
                        </button>
                    )}

                    {/* Botão para criar leads */}
                    {!showForm && (
                        <button
                            title={t('criarLeads')}
                            type="button"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10 dark:bg-gray-700 text-gray-500 rounded-r-[8px] dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}
                            onClick={() => {
                                setShowForm(true);
                                setEditarLead(true);
                                setLeadSelecionado(null);
                            }}>
                            {<NoteAddIcon />}
                        </button>
                    )}

                    {/* Botão para criar uma conta */}
                    {showForm && leadSelecionado && (
                        <button
                            type="submit"
                            title={t('criarConta')}
                            onClick={() => {
                                setNovaConta(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border  border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white ${
                                !leadSelecionado ? 'rounded-r-[8px]' : ''
                            } `}>
                            {leadSelecionado && <PeopleAltOutlinedIcon />}
                        </button>
                    )}

                    {/* Botão para criar uma reunião */}
                    {showForm && leadSelecionado && (
                        <button
                            type="submit"
                            title={t('criarReuniaoVisita')}
                            onClick={() => {
                                setNovaReuniaoVisita(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border  border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white ${
                                !leadSelecionado ? 'rounded-r-[8px]' : ''
                            } `}>
                            {<CalendarTodayOutlinedIcon />}
                        </button>
                    )}

                    {showForm && editarLead && (
                        <button
                            title={t('salvar')}
                            type="submit"
                            onClick={() => {
                                setGuardarLead(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border rounded-r-[8px] border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}>
                            {leadSelecionado ? <SaveAsIcon /> : <SaveIcon />}
                        </button>
                    )}

                    {/* botão para ativar a edição */}
                    {showForm && !editarLead && (
                        <button
                            title={t('editar')}
                            type="submit"
                            onClick={() => {
                                setEditarLead(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border rounded-r-[8px] border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}>
                            {<CreateIcon />}
                        </button>
                    )}
                </div>
            </div>
            <Drawer anchor="right" open={state['right']} onClose={toggleDrawer('right', false)}>
                {list('right')}
            </Drawer>

            {openExit && (
                <ExitForm
                    cancelar={() => setOpenExit(false)}
                    back={() => {
                        setShowForm(false);
                        setEditarLead(false);
                        setLeadSelecionado(null);
                        setOpenExit(false);
                    }}
                />
            )}
        </>
    );
}

export default DrawerFilter;
